import axiosInstance from '@/store/axios'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    ftpUpload ({ commit }, data) {
      const headers = {
        'Content-Type': 'multipart/form-data',
      }
      const params = {}
      if (data.name) {
        params.name = data.name
      }
      return axiosInstance.post('/api/v1/ftp-upload', data.file, {
        params,
        headers,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    zipFtpUpload ({ commit }, data) {
      const headers = {
        'Content-Type': 'multipart/form-data',
      }
      const params = {}
      if (data.name) {
        params.name = data.name
      }
      return axiosInstance.post('/api/v1/zip-upload', data.file, {
        params,
        headers,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },
  },
}
